import mockAxios, { AxiosResponse } from 'axios';

import { IRequisitionServiceMock } from './requisition.mock.types';

export const mockRequisitionService = (): IRequisitionServiceMock => ({
  fetchRequisitions: jest.fn(),
  fetchRequisition: jest.fn(),
  createRequisition: jest.fn(),
  updateRequisition: jest.fn(),
  deleteRequisition: jest.fn(),
  updateRequisitionLine: jest.fn(),
  deleteRequisitionAttachment: jest.fn(),
  updateRequisitionState: jest.fn(),
  fetchRequisitionApprovers: jest.fn(),
  fetchRequisitionBuyers: jest.fn(),
  assignRequisitionBuyer: jest.fn(),
  updateRequisitionOwner: jest.fn(),
  assignRequisitionPONumber: jest.fn(),
  assignRequisitionApprover: jest.fn(),
  exportRequisitionHeader: jest.fn(),
  exportRequisitionLines: jest.fn(),
  fetchRequisitionActivities: jest.fn(),
  // comments
  fetchRequisitionComments: jest.fn(),
  fetchRequisitionComment: jest.fn(),
  createRequisitionComment: jest.fn(),
  updateRequisitionComment: jest.fn(),
  deleteRequisitionComment: jest.fn(),
  addRequisitionCommentAttachments: jest.fn(),
  removeRequisitionCommentAttachment: jest.fn(),

  //export
  exportRequisitionPdf: jest.fn(),
  exportRequisitions: jest.fn(),

  updateMultipleRequisitionOwner: jest.fn(),

  fetchRequisitionCommentsMentionableUsers: jest.fn()
});

export const mockRequisitionAxiosResponse = (): AxiosResponse<unknown> => ({
  data: undefined,
  status: 200,
  statusText: 'OK',
  headers: mockAxios.defaults.headers,
  config: mockAxios.defaults
});
